<template>
    <div id="report-channel-breakdown">
        <div class="overall-content">
            <div class="chart-container">
                <div class="chart-section">
                    <div class="title">
                        <ChartDoddleIcon />
                        <h2>{{ $t('report.channelBreakdown') }}</h2>
                    </div>
                    <ChannelOverallChart
                        :title="$t('report.channelBreakdown')"
                        :filters="filters"
                        :loading="loading"
                        :data="data"
                    />
                </div>
                <a-divider />
            </div>
        </div>
    </div>
</template>
<script>
import log2 from "../../../utils/log2";
import moment from "moment";
import { REPORT_API } from "../../../api/statistics";
import ChartDoddleIcon from "../common/icons/ChartDoddleIcon.vue";
import ChannelOverallChart from "../overall/ChannelOverallChart.vue";

const log = log2("ChannelBreakdown");
export default {
    name: "ChannelBreakdown",
    components: {
        ChannelOverallChart,
        ChartDoddleIcon,
    },
    props: {
        filters: {
            type: Object,
            default: () => ({
                users: [],
                channels: [],
                startDate: moment().startOf("day").toISOString(),
                endDate: moment().endOf("day").toISOString(),
            }),
        },
    },
    data() {
        return {
            loading: true,
            data: {
                buckets: [],
                timeSeriesType: "day",
            },
        };
    },

    methods: {
        async fetch() {
            log("fetchData", this.filters);
            REPORT_API.channelOverall(this.filters)
                .then((res) => {
                    log("channelOverall data fetched", res);
                    this.data = res;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
    mounted() {
        this.fetch();
    },
    watch: {
        filters: {
            handler: function (val, oldVal) {
                this.fetch();
            },
            deep: true,
        },
    },
};
</script>
<style lang="scss" scoped>
#report-channel-breakdown {
    width: 100%;
    height: auto;
    min-height: 100vh;
    display: flex;

    .md-progress-bar {
        position: absolute;
        top: 0;
        width: 100%;
        margin-left: -10px;
    }

    .side-menubar-wrapper {
        min-height: 100vh;
        flex: 0 0 15%;
        height: 100%;
    }

    .overall-content {
        padding: 10px;
        display: flex;
        flex-direction: column;
        position: relative;
        background: white;
        width: 100%;
        height: 100%;
        min-height: 100vh;
        position: relative;

        .chart-container {
            width: 100%;
            display: flex;
            flex-direction: column;
            gap: 20px;

            .chart-section {
                display: flex;
                flex-direction: column;
                gap: 10px;

                .title {
                    display: flex;
                    gap: 4px;
                    align-items: center;

                    justify-content: center;

                    h2 {
                        text-align: center;
                        font-weight: 700;
                        font-size: 40px;
                        margin: 0 !important;
                    }
                }
            }

            .header {
                width: 100%;
            }

            .chart {
                max-width: 1050px;
            }
        }
    }
}
</style>
